import {clearString, rotateAlphabet, getAlphabet} from "../helpers/stringHelpers";

const SEPARATOR = ''
export const methods = {
    cypher: function (input, hasCh = false, missing = [], params, sep = SEPARATOR) {
        let cyphered = []
        let cleared = clearString(input, hasCh)//
        missing.forEach((char) => {
            if (char !== 'ch')
                cleared = cleared.replaceAll(char, '')
        })
        let characters = cleared.split('');
        for (let i = 0; i < characters.length; i++) {
            let char = characters[i];
            if (char.match(/[.,?! ]/)) {
                cyphered.push(char);
            } else {
                let chr = rotateAlphabet(parseInt(params[1]), hasCh)[getAlphabet(hasCh).indexOf(char)];
                cyphered.push(chr);
            }
        }
        return cyphered.join(sep).replaceAll('*', 'ch')
    },
    decypher: function (input, hasCh = false, missing = [], params) {
        let deciphered = []
        let cleared = clearString(input, hasCh)
        let characters = cleared.split('');
        for (let i = 0; i < characters.length; i++) {
            let char = characters[i];
            if (char.match(/[.,?! ]/)) {
                deciphered.push(char);
            } else {
                let chr = getAlphabet(hasCh)[rotateAlphabet(parseInt(params[1]), hasCh).indexOf(char)] ;
                deciphered.push(chr);
            }
        }
        return deciphered.join('').replaceAll('*', 'ch')
    },
};

export default {...methods,SEPARATOR}